import { Injectable } from '@angular/core';
import { forkJoin, map, Observable } from 'rxjs';
import { ColumnDefinition, ColumnVisibility } from '../../../core/model/column-definition';
import { ColumnDefinitionFactory } from '../../../core/service/factory/column-definition-factory.service';
import { ArticleService } from './article.service';
import { ArticleGroupService } from './article-group.service';

@Injectable()
export class ContractExcelColumnsService {
  constructor(
    private readonly factory: ColumnDefinitionFactory,
    private readonly articles: ArticleService,
    private readonly articleGroups: ArticleGroupService
  ) {}

  create(context: string, listColumns: ColumnDefinition[]): Observable<ColumnDefinition[]> {
    return forkJoin([this.articles.getList(), this.articleGroups.getList()]).pipe(map(([articles, groups]) => {
      const columns = [...listColumns];
      const add = (caption: string, binding: string) => {
        if (!columns.some(column => column.binding === binding)) {
          columns.push(this.factory.create(caption, binding, ColumnVisibility.optional));
        }
      };
      [
        ['EXCEL_EXPORT_SETTINGS.APPROVED_AND_SIGNED', 'approvedAndSigned'],
        ['RENTAL_OBJECT_FORM.RENTAL_OBJECT_NUMBER_LABEL', 'rentalObjectRentalId'],
        ['CONST.DIRECT_DEBIT_FROM', 'directDebitFrom'],
        ['CONST.DIRECT_DEBIT_STATUS_TERMINATED', 'directDebitTerminated'],
        ['ADDRESS_FORM.RECIPIENT_LABEL', 'adressRowOne'],
        ['ADDRESS_FORM.ADDRESS_ROW2', 'adressRowTwo'],
        ['ADDRESS_FORM.STREET_LABEL', 'addressStreet'],
        ['ADDRESS_FORM.POSTAL_CODE_LABEL', 'postalCode'],
        ['ADDRESS_FORM.CITY_LABEL', 'city'],
        ['COMMON.EMAIL_INVOICING', 'emailInvoicing'],
        ['LEASE_AGREEMENT.TENANT_TWO', 'tenantTwo'],
        ['LEASE_AGREEMENT.TENANT_TWO_CIVICNUMBER', 'tenantTwoContactIdentification'],
        ['LEASE_AGREEMENT.TENANT_TWO_PHONE', 'tenantTwoPhone'],
        ['LEASE_AGREEMENT.TENANT_TWO_EMAIL', 'tenantTwoEmail'],
      ].forEach(([caption, binding]) => add(caption, binding));
      if (context === 'PremisesContract') {
        add('EXCEL_EXPORT_SETTINGS.TENANT_CONTACT_PERSON', 'tenantOneReferenceName');
      }
      if (context === 'CooperativeHousingContract') {
        [
          ['COOPERATIVE_HOUSING.SHARE', 'condominiumShare'],
          ['COOPERATIVE_HOUSING.ECONOMICAL_PLAN_NUMBER', 'economicalPlanNumber'],
        ].forEach(([caption, binding]) => add(caption, binding));
      }
      if (context === 'PremisesContract' || context === 'CooperativeHousingContract') {
        groups.forEach(group => add(group.name, `articleGroup.${group.id}`));
        articles
          .filter(article => context === 'PremisesContract' ? article.premisesCategory : article.dwellingCategory)
          .forEach(article => add(`${article.code} ${article.caption}`, `article.${article.id}`));
      }
      return columns;
    }));
  }
}
